// extracted by mini-css-extract-plugin
export const about = "about-module--about--2rBlf";
export const divBefore = "about-module--divBefore--3-eHh";
export const aboutMe = "about-module--about-me--3TtaN";
export const tilt = "about-module--tilt--1J52y";
export const aboutMeItem = "about-module--about-me-item--3XvEY";
export const img = "about-module--img--14rGK";
export const aboutMeItemContent = "about-module--about-me-item-content--pwoB3";
export const references = "about-module--references--3dv3f";
export const referencesItem = "about-module--referencesItem--2bBzi";
export const referencesItemContent = "about-module--referencesItemContent--10Y4L";
export const skillsHobbies = "about-module--skills-hobbies--1Wmp-";
export const skillsHobbiesContent = "about-module--skills-hobbies-content--2WPcg";
export const hobbies = "about-module--hobbies--bVOH9";